import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../../assets/images/logos/logo.png";
import { LocationOn, Phone, Email, Facebook, Instagram, Twitter } from "@mui/icons-material";

export default function Footer({ categories, brands }) {

  const socialLinks = [
    { name: "Facebook", icon: <Facebook />, url: "https://facebook.com" },
    { name: "Instagram", icon: <Instagram />, url: "https://instagram.com" },
    { name: "Twitter", icon: <Twitter />, url: "https://twitter.com" },
  ];
  // const countries = ["UAE", "Saudi Arabia", "Kuwait", "Qatar", "Oman", "Bahrain"];

  return (
    <footer className="footer">
      <div className="footer-top custom-container">
        <section className="footer-col footer-brand">
          <img src={logo} alt="Spa Mart - Multi-brand Supplier for Spa, Salon, Hotel & Wellness Products in UAE & GCC" className="footer-logo" />
          <p className="footer-desc">
            Trusted multi-brand supplier of spa, salon, hotel, massage, and recreation wellness products across the UAE & GCC.
          </p>
        </section>

        <nav className="footer-col" aria-label="Shop by Category">
          <h4 className="footer-title">Shop by Category</h4>
          <ul>
            {categories.map((cat) => (
              <li key={cat.slug}>
                <Link to={`/${cat.slug}`} className="footer-link">{cat.name}</Link>
              </li>
            ))}
          </ul>
        </nav>


        <nav className="footer-col" aria-label="Shop by Category">
          <h4 className="footer-title">Shop by Brands</h4>
          <ul>
            {brands.map((brand) => (
              <li key={brand.slug}>
                <Link to={`/brand/${brand.slug}`} className="footer-link">{brand.name}</Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* <nav className="footer-col" aria-label="Explore Pages">
          <h4 className="footer-title">Explore</h4>
          <ul>
            {aboutLinks.map((link) => (
              <li key={link}>
                <Link to={`/${link.toLowerCase().replace(/\s+/g, "-")}`} className="footer-link">{link}</Link>
              </li>
            ))}
          </ul>
        </nav> */}

        <section className="footer-col py-2">
          <h4 className="footer-title">Contact Info</h4>
          <address className="footer-contact">
            <p><LocationOn /> Abu Dhabi, United Arab Emirates</p>
            <p><Phone /> <a href="tel:+971500000000">+971 588 38 2030</a></p>
            <p><Email /> <a href="mailto:enquiry@spabrands.me">enquiry@spabrands.me</a></p>
          </address>

          {/* <div className="footer-social">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label={social.name}
              >
                {social.icon}
              </a>
            ))}
          </div> */}
        </section>
      </div>

      {/* <nav className="footer-countries" aria-label="Countries">
        {countries.map((country) => (
          <Link key={country} to={`/country/${country.toLowerCase().replace(/\s+/g, "-")}`} className="country-link">
            {country}
          </Link>
        ))}
      </nav> */}

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Spa Brands. All rights reserved.</p>
      </div>
    </footer>
  );
}
